<template>
  <ColumnEditModal :value="value" :configName="configName" :columnId="columnId" :editMode="editMode" @input="$emit('input', $event)" v-bind="$attrs">
    <template v-slot:edit-modal-additions="props">
      <v-layout pa-4 wrap>
        <h3> If the cell contains a value, the cell in the "Sample Date Time Day" column must be an integer. </h3>
        <v-radio-group column :value="getShouldValidateDataTypeValue(props.columnConfiguration)" @change="callSetColumnMetadata(shouldValidateDataTypeKey, !(getShouldValidateDataTypeValue(props.columnConfiguration)))">
          <v-radio class="radio-opts" label="The import will fail if an integer outside the range of 1-31 is detected." :value="true" />
        </v-radio-group>
      </v-layout>
    </template>
  </ColumnEditModal>
</template>
<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'
  const eddConfiguration = createNamespacedHelpers('plugin/eddConfiguration')
  import ColumnEditModal from './ColumnEditModal'
  import metadataFieldNames from '../../store/metadataFieldNames'

  export default {
    components: {
      ColumnEditModal,
    },
    props: {
      value: {
        type: Boolean,
        default: false,
      },
      configName: {
        type: String,
        required: true,
      },
      columnId: {
        type: String,
        required: true,
      },
      editMode: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        shouldValidateDataTypeKey: metadataFieldNames.depthStart_validateDataType,
      }
    },
    methods: {
      ...eddConfiguration.mapActions(['setColumnMetadata']),
      callSetColumnMetadata(metadataFieldName, metadataValue) {
        this.setColumnMetadata({
          configName: this.configName,
          columnId: this.columnId,
          metadataKey: metadataFieldName,
          metadataValue: metadataValue,
        })
      },
      getShouldValidateDataTypeValue(columnConfiguration) {
        return (columnConfiguration && columnConfiguration.Metadata && columnConfiguration.Metadata[this
          .shouldValidateDataTypeKey]) || false
      },
    },
  }
</script>